<template>
  <div class="all-series">
    <div class="top-section">
      <h1>תוכניות אימונים וסדרות</h1>
      <h2>מה מעניין אותך?</h2>
      <div class="has-text-centered">
        <router-link to="seriescategory/all">לכל הסדרות והתוכניות</router-link>
      </div>
    </div>
    <div class="container">
      <div class="columns is-multiline is-centered">
        <series-cat-button
          v-for="cat in $store.state.initialData.seriesCategories"
          :key="cat.MIGX_id"
          :category="cat"
        ></series-cat-button>
      </div>
    </div>
  </div>
</template>

<script>
import SeriesCatButton from "@/components/series/seriesCatButton.vue";
export default {
  components: {
    SeriesCatButton,
  },
};
</script>

<style lang="scss">
.all-series {
  h1 {
    color: #000000;
    font-weight: bold;
    text-align: center;
  }
  h2 {
    text-align: center;
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }
  .has-text-centered {
    a {
      color: #000000;
      text-decoration: underline;
      font-size: 1.1rem;
    }
  }
}
</style>